<template>
  <div class="container">
    <h1>
      <b-icon icon="person-square"></b-icon> Add/Drop Request
      <div class="float-right" style="margin-top: -62px">
        <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help">
          <b-icon icon="question-square-fill"></b-icon> Help</b-button>
        <help id="111" />
      </div>
    </h1>

    <div class="row">
      <div class="col-md-3 img-responsive">
        <img src="../../assets/RegistrationHome.jpg" width="350" alt="Circle image" class="militray-img" />
      </div>
      <div class="col-md-9 pt-4">
        <div class="panal mt-20" style="margin-left: -48px">
          <div class="panal-body row pl-5">
            <h1 class="w-100"> Add/Drop Request</h1>
            <p>
              "Students can submit an Add/Drop Request to add new courses or drop existing ones,

              and the request will remain pending until reviewed and approved by Academic Adviser."
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="row w-100">

<div class="accordion w-100" role="tablist">
  <div class="panal col-md-12"  v-if="status.StudentRegistrationApproval != 1 && status.AdvisingStatus != true">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info" class="panal-header">Drop Courses</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
           
           
            <div class="panal-body">

            </div>
            <!-- <div class="col-md-12 text-center" v-if="basicCourses.length >0">

      <h5>Your Currently selected Courses</h5>
    </div> -->
            <div class="row m-1">
             

              <div class="text-center" v-if="loadCourses ">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </div>
              <div v-for="(request, index) of basicCoursesDrop" :key="index" class="col-md-4 col-sm-12 mb-5"
                border-variant="primary">

                <div class="card p-4" :class="{ 'pink-card': request.isPink }" style="min-height: 230px;">
                  <b-card-text><strong>Course Code :
                      <span class="customeP">{{ request.CourseCode }} </span>
                    </strong>
                  </b-card-text>
                  <b-card-text><strong>Course Name :
                      <span class="customeP">{{ request.CourseNameEN }} </span>
                    </strong>
                  </b-card-text>
                  <b-card-text>  <strong
                >Course Status :
                <b-badge
                  v-if="request.CourseStatus == 'Approved'"
                  variant="success"
                  >Approved</b-badge
                >
                <b-badge
                  v-else-if="request.CourseStatus == 'Declined'"
                  variant="danger"
                  >Rejected</b-badge
                >
                <b-badge
                  v-else-if="request.CourseStatus == 'Pending'"
                  variant="info"
                  >Pending</b-badge
                >
                <b-badge v-else variant="warning">---</b-badge>
              </strong></b-card-text>
                  <!-- @click="DeleteRegesteredCourses(request.CourseID)" -->
                  <button 
                   :class="['btn',
                   !request.CourseStatus ? 'btn-danger' : 
                   request.CourseStatus === 'Approved' ? 'btn-success' : 
                   request.CourseStatus === 'Declined' ? 'btn-danger' : 
                   request.CourseStatus === 'Pending' ? 'btn-warning' : 'btn-warning'
  ]"
                   @click="handleButtonClick(request)">
                   {{ request.CourseStatus ? request.CourseStatus : 'Drop Request' }}</button>

                  <div class="clearfix"></div>
                </div>
              </div>
            </div>

         
        </b-card-body>
      </b-collapse>
    </b-card>
 </div>
 <div class="panal col-md-12" >
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2  class="panal-header">Add Courses</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
           
           
            <div class="panal-body">

            </div>
            <!-- <div class="col-md-12 text-center" v-if="basicCourses.length >0">

      <h5>Your Currently selected Courses</h5>
    </div> -->
            <div class="row m-1">
         

              <div class="text-center" v-if="loadCourses ">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </div>
             
              <div v-for="(request, index) of CoursesFAdd" :key="index" class="col-md-4 col-sm-12 mb-5"
                border-variant="primary" >
<div v-if="!request.isRegistered">
                <div class="card p-4" :class="{ 'pink-card': request.isPink }" style="min-height: 230px;">
                  <b-card-text><strong>Course Name :
                      <span class="customeP">{{ request.CourseNameEN }} </span>
                    </strong>
                  </b-card-text>
                  <b-card-text><strong>Credit Hours :
                      <span class="customeP">{{ request.CreditHours }} </span>
                    </strong>
                  </b-card-text>
                                 <b-card-text>  <strong
                >Course Status :
                <b-badge
                  v-if="request.CourseStatus == 'Approved'"
                  variant="success"
                  >Approved</b-badge
                >
                <b-badge
                  v-else-if="request.CourseStatus == 'Declined'"
                  variant="danger"
                  >Rejected</b-badge
                >
                <b-badge
                  v-else-if="request.CourseStatus == 'Pending'"
                  variant="info"
                  >Pending</b-badge
                >
                <b-badge v-else variant="warning">---</b-badge>
              </strong></b-card-text>
                  <!-- @click="DeleteRegesteredCourses(request.CourseID)" -->
                  <button 
                   :class="['btn',
                   !request.CourseStatus ? 'btn-danger' : 
                   request.CourseStatus === 'Approved' ? 'btn-success' : 
                   request.CourseStatus === 'Declined' ? 'btn-danger' : 
                   request.CourseStatus === 'Pending' ? 'btn-warning' : 'btn-warning'
  ]" 
                   @click="handleButtonClick2(request)">{{ request.CourseStatus ? request.CourseStatus : 'Add Request' }}</button>

                  <div class="clearfix"></div>
                </div></div>
              </div>
            </div>

        
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>

  </div>





           <!-- BootstrapVue Confirmation Modal -->
    <b-modal id="confirm-drop-modal" ref="confirmDropModal" hide-footer title="Confirm Drop" centered>
      <div class="d-block text-center">
        <p class="mb-4">Are you sure you want to <strong class="text-danger">drop this course</strong>?</p>
        <b-button variant="danger" class="mr-2" @click="confirmDrop">Yes, Drop</b-button>
        <b-button variant="secondary" @click="$refs.confirmDropModal.hide()">Cancel</b-button>
      </div>
    </b-modal>


         


             <b-modal id="confirm-Add-modal" ref="confirmAddModal" hide-footer title="Confirm Add" centered>
      <div class="d-block text-center">
        <p class="mb-4">Are you sure you want to <strong class="text-danger">Add this course</strong>?</p>
        <b-button variant="danger" class="mr-2" @click="confirmAdd">Yes, Add</b-button>
        <b-button variant="secondary" @click="$refs.confirmAddModal.hide()">Cancel</b-button>
      </div>
    </b-modal>





        </div>
      </div>
    </div>
  </div>
</template>

<script>


import SelectSubject from "../../services/academic/SelectSubject.services";
//import ApplicantService from "../../services/Applicant/Applicant.service";
//import StudentAdvisorServices from '../../services/academic/StudentAdvicessServices'
import Help from '../Help.vue';

export default {
  
  components: { Help },
  name: "SelectSubject",
  data() {
    return {
      props: ["request", "allowUpdateDrop"],
      empty : true, 
      info:"",
      LevelName : [],
        message:'',
        Specialization:[],
        courseCode:'',
        courseName:'',
        Specializationinsert:null,
        LevelNameinsert:null,
        status : [],
        basicCourses:[],
        allowUpdateDrop:false,
        allowButtonDrop:false,
        loading:false,
        loadCourses:false,
       selectSubjectList: [],
       Courses:[],
       basicCoursesDrop:[],
       RequestCourse:[],
       CoursesFAdd:[],
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
    StudentStatus(){
          this.$store.dispatch('Advisor/AdvisorStatus',this.currenUser.StudentID)

    return this.$store.state.Advisor
    },
    
  },

  created(){
    this.$store.dispatch('Advisor/AdvisorStatus',this.currenUser.StudentID),
               studentData.GetCoursesForSelection(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert,this.LevelNameinsert,this.text1,this.text2,this.IsSelected).then(Response =>{
              //this.isLoading = false ;
               this.Courses = Response.data
                this.empty =false
               // eslint-disable-next-line no-console
            this.loading = false
                this.Courses =  this.Courses.map(gr=>{
                 return {...gr,Grades :[{GradeSerial : 0 , GradeName : "Choose"},...gr.Grades] }
                 
               })
           }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })

      // SelectSubject.GetFacultyLevels(this.currenUser.FacultyID_Enrollment).then(Response =>{
               
      //          this.LevelName = Response.data
      //           this.empty =false
      //           // console.log('levels name: ', this.LevelName)
      //      }, error => {
      
      //         this.message =
      //           (error.response && error.response.data && error.response.data.Message) ||
      //           error.message ||
      //           error.toString();
                
      //           if(error.response.status == 404) this.message =''
             
      //       }) 
       
      // SelectSubject.GetFacultySpecializations(this.currenUser.FacultyID_Enrollment).then(Response =>{
             
      //          this.Specialization = Response.data
      //           this.empty =false
            
      //      }, error => {
              
      //             // eslint-disable-next-line no-console
      //             // console.log(error.response.status)
                 
      //         this.message =
      //           (error.response && error.response.data && error.response.data.Message) ||
      //           error.message ||
      //           error.toString();
                
      //           if(error.response.status == 404) this.message =''
             
      //       }) 
      // StudentAdvisorServices.StudentAdvisingStatus(this.currenUser.StudentID).then((Response) => {
        
      //   this.status = Response.data[0]
      //     // eslint-disable-next-line no-console
      //      console.log("Select Subject ", Response.data);
      //   },
      //   (error) => {
        
    
      //     this.message =
      //       (error.response &&
      //         error.response.data &&
      //         error.response.data.Message) ||
      //       error.message ||
      //       error.toString();

      //     if (error.response.status == 404) this.message = "";
      //   }
      // );
  },

  async mounted() {
    await this.GetRegistrationCoursesDrop();
    await this.GetStudentScheduleDrop();
   await this.GetRegistrationPeriodSelect()
    await this.SelectBasicCourses()
    await this.getAllStudentRegistrationCourses();
    
           SelectSubject.RegistrationRequest_GetRequestPeriodSelect().then(res=>{
              console.log(res.data)

              this.allowButtonDrop = res.data[0].IsActive ;
             
              this.loading = false
            }).catch(()=>{
              this.loading = false
            })

  



      

  },

  methods: {
    makePink(req) {
      // ensure property exists so Vue reacts
      this.$set(req, "isPink", true)   // ✅ Vue 2
      // req.isPink = true             // ✅ Vue 3
    },
   


  //  async getAllStudentRegistrationCourses() {
  //     // 22, 0, 0, 0, 'p', 'p', 3
  //     this.isLoading =true
  //    await SelectSubject.GetStudentRegistrationCourses(this.currenUser.StudentID, this.currenUser.FacultyID_Enrollment,
  //                            0, 0, "", "", 3 ).then( (Response) => {
        
  //         this.selectSubjectList = Response.data;
          
  //         if(this.selectSubjectList.length == 0) {
  //           this.isLoading = false;
  //         this.empty = true}else{
  //           this.empty =false
  //        this.selectSubjectList =  this.selectSubjectList.map(item => {
  //           return new Course(item.CourseCode,item.CourseNameEN,
  //         item.CourseStateID,item.CreditHours,item.Description,item.serial,item.isRegistered )
  //         }) 
  //          .filter(Course => Course.isRegistered == 0);
  //           this.isLoading = false;
  //         }
  //         // eslint-disable-next-line no-console
  //         // console.log("Select Subject ", Response.data);
  //       },
  //       (error) => {
  //         // eslint-disable-next-line no-console
  //         // console.log(error.response.status);
  //         this.isLoading = false ;
  //         this.message =
  //           (error.response &&
  //             error.response.data &&
  //             error.response.data.Message) ||
  //           error.message ||
  //           error.toString();

  //         if (error.response.status == 404) this.message = "";
  //       }
  //     );
  //   },
 handleButtonClick(request) {
    // ✅ Open modal only if CourseStatus is empty
    if (!request.CourseStatus) {
      this.openConfirmModal(request.CourseID);
    }
  },

    openConfirmModal(courseId) {
      this.courseToDrop = courseId;
      this.$refs.confirmDropModal.show();
    },
    confirmDrop() {
      this.Dropcourse(this.courseToDrop, 'Drop');
      this.$refs.confirmDropModal.hide();
    },

    handleButtonClick2(request) {
    if (!request.CourseStatus) {
      // Only open the modal if CourseStatus is empty
      this.openConfirmModalAdd(request.serial, 'Add');
    } else {
      // Optionally, show a message or disable interaction
      console.log('Request already has a status:', request.CourseStatus);
    }
  },

  openConfirmModalAdd(CourseSerial) {
      this.courseToAdd = CourseSerial;
      this.$refs.confirmAddModal.show();
    },
    confirmAdd() {
      this.Addcourse(this.courseToAdd, 'Add');
      this.$refs.confirmAddModal.hide();
    },

GetRegistrationCoursesDrop(){
     this.loadCourses = true
      SelectSubject.GetRegistrationCoursesDrop(this.currenUser.StudentID).then(res=>{
        this.CoursesFAdd = res.data
       this.loadCourses =false
      }).catch(()=>{
        this.loadCourses = false
      })
    },


GetStudentScheduleDrop(){
     this.loadCourses = true
      SelectSubject.GetStudentScheduleDrop(this.currenUser.StudentID).then(res=>{
        this.basicCoursesDrop = res.data
       this.loadCourses =false
      }).catch(()=>{
        this.loadCourses = false
      })
    },


    Dropcourse(CourseSerial){

         SelectSubject.RequestCourse(this.currenUser.StudentID,CourseSerial,"Drop").then(res=>{
        this.RequestCourse = res.data
       this.loadCourses =false
        this.GetStudentScheduleDrop();
      }).catch(()=>{
        this.loadCourses = false
      })

    },

      Addcourse(CourseSerial){

         SelectSubject.RequestCourse(this.currenUser.StudentID,CourseSerial,"Add").then(res=>{
        this.RequestCourse = res.data
       this.loadCourses =false
        this.GetRegistrationCoursesDrop();
      }).catch(()=>{
        this.loadCourses = false
      })

    },

   
                           
        
    SelectBasicCourses(){
     this.loadCourses = true
      SelectSubject.SelectBasicCourses(this.currenUser.StudentID).then(res=>{
        this.basicCourses = res.data
       this.loadCourses =false
      }).catch(()=>{
        this.loadCourses = false
      })
    },
    async  GetRegistrationPeriodSelect(){
      this.loading = true
    SelectSubject.GetRegistrationPeriodSelect().then(res=>{
              //console.log(res.data)
              this.allowUpdateDrop = res.data[0].IsActive
              this.loading = false
            }).catch(()=>{
              this.loading = false
            })
           }

  },
};
</script>

<style scoped>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
.modal-footer {
  background: #f6f6f6 !important;
}

.panal {
  background: rgb(255, 255, 255);
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
    background: #285475;
    color: #ffffff;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
}
.panal-body {
  padding: 20px;
  color: #333;
}

/* Style the tabs */
.tabs {
  overflow: hidden;
  margin-left: 20px;
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 12px 24px;
  transition: background-color 0.2s;
  border: 1px solid #ccc;
  border-right: none;
  background-color: #285475;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  color: #fff;
}
.tabs a:last-child {
  border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #285475;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

.pink-card {
  background-color: pink !important;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none;
  }
  img {
    width: 69vw !important;
  }
}
.spicon {
  color: #ff8600;
  font-size: 45px;
  font-weight: 800;
}
.customeP {
  /* white-space: nowrap; */
  font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
</style>
